module.exports = __webpack_public_path__ + "fonts/Trade-Gothic-LT.ttf";


//////////////////
// WEBPACK FOOTER
// ./Common/fonts/Trade-Gothic-LT.ttf
// module id = 22
// module chunks = 0 1 2 3 4 5 6 7